/* eslint-disable react/no-unescaped-entities */
import {useIntl} from 'react-intl';
import {useEffect} from 'react';
import {useAuth} from '../../../auth/hooks/useAuth';

import Loading from '../../../../components/Loading';
import Layout from '../../components/Layout';

const ReactivateSuccess = () => {
  const {formatMessage} = useIntl();
  const {signOut, isAdmin, user} = useAuth();
  const {company} = user;

  useEffect(() => {
    setTimeout(() => {
      // Redirect to dashboard if company exists
      window.location.href = 'https://app.trackmyguys.com/dashboard';
    }, 3000);
  }, [company]);

  return (
    <Layout isAdmin={isAdmin} signOut={() => signOut()}>
      {!company ? (
        <Loading />
      ) : (
        <div className="flex items-center justify-center min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
          <div className="w-full max-w-2xl p-12 mx-4 text-center transition-all transform bg-white shadow-lg rounded-xl hover:shadow-xl">
            <div className="flex items-center justify-center w-24 h-24 mx-auto mb-8 bg-green-100 rounded-full">
              <svg
                className="w-12 h-12 text-green-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>

            <h1 className="mb-6 text-4xl font-extrabold text-green-600">
              {formatMessage({id: 'success.page.title'})}
            </h1>

            <p className="mb-8 text-xl text-gray-700">
              {formatMessage({id: 'success.page.description'})}
            </p>

            <div className="p-6 mb-8 rounded-lg bg-yellow-50">
              <p className="text-lg font-medium text-yellow-700">
                {formatMessage({id: 'success.page.disclaimer'})}
              </p>
            </div>

            <div className="pt-8 mt-8 border-t border-gray-100">
              <p className="text-lg text-gray-700">
                {formatMessage({id: 'success.page.question'})}
              </p>
              <a
                href="mailto:contact@workpodium.com"
                className="inline-block mt-2 text-xl font-medium text-blue-600 transition-colors duration-200 hover:text-blue-800">
                contact@workpodium.com
              </a>
            </div>

            <div className="mt-12">
              <a
                href="https://app.trackmyguys.com/dashboard"
                className="inline-block px-8 py-4 text-lg font-semibold text-white transition-colors duration-200 bg-yellow-500 rounded-lg hover:bg-yellow-600">
                {formatMessage({id: 'success.page.cta'})}
              </a>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default ReactivateSuccess;
